import React from 'react'

const Error500Banner = () => {
  const lettersAnimation = '10s'
  const barsAnimation = '5s'

  return (
      <svg
          viewBox="0 0 1010 360"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="error-page__banner-container"
      >
        <path
            d="M204.2 382.8C184.2 382.8 166.867 378.933 152.2 371.2C137.8 363.2 126.467 352.8 118.2 340C109.933 327.2 104.867 313.333 103 298.4H159C161.667 310.133 167 318.933 175 324.8C183.267 330.667 192.733 333.6 203.4 333.6C217.8 333.6 229 328.933 237 319.6C245 310 249 297.733 249 282.8C249 267.6 244.867 255.333 236.6 246C228.6 236.667 217.267 232 202.6 232C182.867 232 169 241.067 161 259.2L106.2 258.4L113.8 100H287.4V150.4H159L155.4 219.2H157.8C161.533 213.333 168.067 207.467 177.4 201.6C186.733 195.733 199.933 192.8 217 192.8C243.933 192.8 265.133 200.933 280.6 217.2C296.333 233.467 304.2 255.333 304.2 282.8C304.2 300.667 300.333 317.2 292.6 332.4C285.133 347.6 273.933 359.867 259 369.2C244.067 378.267 225.8 382.8 204.2 382.8Z"
            fill="#E5E7EB"
        >
          <animate
            attributeType="XML"
            attributeName="fill"
            values="#E5E7EB;#9CA3AF;#E5E7EB"
            dur={lettersAnimation}
            repeatCount="indefinite"
          />
        </path>
        <path d="M418.6 265.5V268" stroke="#9CA3AF" strokeLinecap="round" />
        <path d="M434.6 166V333" stroke="#E5E7EB" />
        <path d="M519.6 166V333" stroke="#E5E7EB" />
        <path d="M477.6 153V333" stroke="#E5E7EB" />
        <circle cx="477.6" cy="218" r="17" fill="#F3F4F6" stroke="#9CA3AF" />
        <circle cx="477.6" cy="218" r="11" fill="#F3F4F6" stroke="#9CA3AF" />
        <circle cx="418.6" cy="280.5" r="5" stroke="#9CA3AF" />
        <circle cx="418.6" cy="266.5" r="4" stroke="#9CA3AF" />
        <path d="M418.1 280.5H430.1" stroke="#9CA3AF" strokeWidth="4" strokeLinecap="round" />
        <path
            d="M477.1 98C405.027 98 346.6 156.658 346.6 229.017V338.5H401.188V229.017C401.188 186.926 435.175 152.805 477.1 152.805C519.025 152.805 553.012 186.926 553.012 229.017V338.5H607.6V229.017C607.6 156.658 549.173 98 477.1 98Z"
            fill="#E5E7EB"
        >
          <animate
            attributeType="XML"
            attributeName="fill"
            values="#E5E7EB;#9CA3AF;#E5E7EB"
            dur={lettersAnimation}
            repeatCount="indefinite"
          />
        </path>
        <path
            d="M401.188 338.5V229.017C401.188 186.926 435.175 152.805 477.1 152.805C519.025 152.805 553.012 186.926 553.012 229.017V338.5"
            stroke="#9CA3AF"
            strokeWidth="3"
        />
        <path d="M718 265.5V268" stroke="#9CA3AF" strokeLinecap="round" />
        <path d="M734 166V333" stroke="#E5E7EB" />
        <path d="M819 166V333" stroke="#E5E7EB" />
        <path d="M777 153V333" stroke="#E5E7EB" />
        <circle cx="777" cy="218" r="17" fill="#F3F4F6" stroke="#9CA3AF" />
        <circle cx="777" cy="218" r="11" fill="#F3F4F6" stroke="#9CA3AF" />
        <circle cx="718" cy="280.5" r="5" stroke="#9CA3AF" />
        <circle cx="718" cy="266.5" r="4" stroke="#9CA3AF" />
        <path d="M717.5 280.5H729.5" stroke="#9CA3AF" strokeWidth="4" strokeLinecap="round" />
        <path
            d="M776.5 98C704.427 98 646 156.658 646 229.017V338.5H700.588V229.017C700.588 186.926 734.575 152.805 776.5 152.805C818.425 152.805 852.412 186.926 852.412 229.017V338.5H907V229.017C907 156.658 848.573 98 776.5 98Z"
            fill="#E5E7EB"
        >
          <animate
            attributeType="XML"
            attributeName="fill"
            values="#E5E7EB;#9CA3AF;#E5E7EB"
            dur={lettersAnimation}
            repeatCount="indefinite"
          />
        </path>
        <path
            d="M700.588 338.5V229.017C700.588 186.926 734.575 152.805 776.5 152.805C818.425 152.805 852.412 186.926 852.412 229.017V338.5"
            stroke="#9CA3AF"
            strokeWidth="3"
        />
        <rect x="40.6454" y="156.638" width="47.2979" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="40.6454;30;40.6454"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="629.752" y="52.5532" width="47.2979" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="629.752;639;629.752"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="954.34" y="244.227" width="47.2979" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="954.34;944;954.34"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="7.36169" y="209.191" width="31.5319" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="7.36169;0;7.36169"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="647.27" width="31.5319" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="647.27;657;647.27"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="7.36169" y="182.915" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="7.36169;17;7.36169"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="652.525" y="26.2766" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="652.525;642;652.525"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="917.553" y="217.95" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="917.553;927;917.553"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="367.206" y="49.0496" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
          <animate
            attributeType="XML"
            attributeName="x"
            values="367.206;357;367.206"
            dur={barsAnimation}
            repeatCount="indefinite"
          />
        </rect>
        <rect x="5" y="338" width="1000" height="75" fill="#F3F4F6" />
        <path d="M5 337.5H1005" stroke="#9CA3AF" strokeWidth="10" strokeLinecap="round" />
      </svg>
  )
}

export default Error500Banner
